import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const ButtonFloat = ({ number }) => {
  return (
    <Link to="/mis-experiencias" className="d-lg-none d-xl-none">
      <div className="btn-float-cart">
        {
          number === 0 ? '' : (
            <span className="count">{number}</span>
          )
        }
        <i className="fas fa-shopping-cart" />
      </div>
    </Link>
  );
};

ButtonFloat.propTypes = {
  number: PropTypes.number.isRequired,
};

export default ButtonFloat;
